import React from "react"
import styled, { css } from "styled-components"
import Marked from "./Marked"

export const TextStyled = styled.p`
  ${({
  theme,
  size,
  weight,
  color,
  align,
}) => {
    const family = theme.fonts.family.primary
    const fontSize = theme.fonts.size[size].fontSize
    const fontWeight = theme.fonts.size[size].weight
      || theme.fonts.weight[weight]
    const lineHeight = theme.fonts.size[size].lineHeight
    const textColor = theme.text[color]

    return css`
      font-family: ${family};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      line-height: ${lineHeight};
      color: ${textColor};
      text-align: ${align};
      white-space: pre-line;
    `
  }}
`

const Text = ({
  size = 'base',
  weight = 'normal',
  color = 'default',
  align = 'left',
  children,
  as,
}) => {

  const isArray = Array.isArray(children)

  const newChildren = isArray ? children : [children]

  const hasMark = newChildren?.some(item => {
    if (typeof item === 'string') {
      return item?.includes('(*)')
    }
    return false
  })


  if (hasMark) return (
    <Marked
      size={size}
      weight={weight}
      color={color}
      align={align}
      as={as}
    >
      {newChildren}
    </Marked>
  )

  return (
    <TextStyled
      size={size}
      weight={weight}
      color={color}
      align={align}
      as={as}
    >
      {children}
    </TextStyled>
  )
}

export default React.memo(Text)